var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('create-map',{attrs:{"existingMap":_vm.existingMap},on:{"create-map-fn":_vm.createMapFn}}),_c('map-editor',{attrs:{"existingMap":_vm.existingMap,"mapData":_vm.mapData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }